import { Outlet, createFileRoute } from '@tanstack/react-router';
import { getGetCompanyByIdQueryOptions } from '@area-restrita/api-client/endpoints/companies/companies.gen';

import { ILinkAuth, useAuthorizationLinks } from '@/utils/linkAuth';
import PageContainer from '@/components/layout/PageContainer';
import SidebarNav from '@/components/layout/SidebarNav';

const sidebarNavItems: ILinkAuth[] = [
  {
    label: 'Visão Geral',
    to: '/companies/$companyId',
    authorization: ({ can }) => can('viewDetails', 'companies'),
  },
  {
    label: 'Usuários',
    to: '/companies/$companyId/users',
    authorization: ({ can }) => can('list', 'company_memberships'),
  },
];

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/companies/$companyId',
)({
  loader: async ({ params: { companyId }, context: { queryClient } }) => {
    const company = await queryClient.ensureQueryData({
      ...getGetCompanyByIdQueryOptions(companyId),
      gcTime: 0,
      revalidateIfStale: true,
    });

    return company;
  },
  component: function CompanyPage() {
    const company = Route.useLoaderData();
    const items = useAuthorizationLinks(sidebarNavItems);

    return (
      <PageContainer title={`Empresa: ${company.tradingName}`} withSeparator>
        <div className="flex flex-1 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 w-full">
          <aside className="-mx-4 lg:w-1/5">
            <SidebarNav items={items} />
          </aside>
          <Outlet />
        </div>
      </PageContainer>
    );
  },
});
